import Reveal from "@/components/feature/Reveal";

const heroTags = ["学校回应", "同学爆料", "班级群聊", "处分结果"];

export default function HeroSpread() {
  return (
    <section id="top" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 pt-8 md:px-8 md:pt-12">
        <div className="flex items-center justify-between border-b border-foreground-900/10 pb-3 text-[11px] tracking-[0.28em] text-foreground-500">
          <span className="font-label">本期封面 · COVER STORY</span>
          <span className="hidden font-label sm:block">深度 · 校园事件脉络</span>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-4 pb-14 pt-8 md:px-8 md:pb-24 md:pt-12">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-0">
          <Reveal className="lg:pr-12 xl:pr-16">
            <div className="flex flex-wrap items-center gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1 text-xs text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>

            <h2 className="mt-6 font-heading text-[2rem] font-black leading-[1.16] text-foreground-950 sm:text-4xl md:text-5xl xl:text-[3.4rem]">
              校园事件里的回应、爆料与处分，
              <span className="text-accent-600">一次看清前因后果</span>
            </h2>

            <p className="mt-6 max-w-2xl text-base leading-loose text-foreground-600 md:text-lg">
              <strong className="font-semibold text-foreground-900">黑料学生</strong> 把每一则
              <strong className="font-semibold text-foreground-900">校园事件</strong>
              摊开成可阅读的时间线：学校如何回应、同学提供了哪些线索、班级群里又流传着什么说法，
              最后又落到怎样的处理结果。我们不急着下结论，只把公开信息按顺序摆好。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#focus"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                本期焦点事件
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </a>
              <a
                href="#topics"
                className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-900/15 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-900/30"
              >
                浏览话题墙
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-3 gap-4 border-t border-foreground-900/10 pt-6">
              <div>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">312</dt>
                <dd className="mt-1 text-xs text-foreground-500">收录校园事件</dd>
              </div>
              <div>
                <dt className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">186</dt>
                <dd className="mt-1 text-xs text-foreground-500">学校公开回应</dd>
              </div>
              <div>
                <dt className="font-heading text-2xl font-bold text-accent-600 md:text-3xl">74</dt>
                <dd className="mt-1 text-xs text-foreground-500">已公示处分结果</dd>
              </div>
            </dl>
          </Reveal>

          <Reveal className="lg:border-l lg:border-foreground-900/10 lg:pl-12 xl:pl-16" delay={120}>
            <figure>
              <div className="aspect-[4/5] w-full overflow-hidden rounded-lg border border-foreground-900/10 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20an%20empty%20school%20corridor%20at%20golden%20hour%2C%20warm%20cream%20paper%20tones%20with%20amber%20and%20terracotta%20accents%2C%20soft%20long%20shadows%20on%20polished%20floor%2C%20muted%20grainy%20magazine%20texture%2C%20calm%20contemplative%20mood%2C%20no%20text%2C%20no%20faces%2C%20flat%20artistic%20composition%2C%20consistent%20warm%20palette&width=900&height=1125&seq=campus-file-cover-01&orientation=portrait"
                  alt="校园走廊封面影像，黑料学生本期封面"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <figcaption className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                <span className="h-1 w-1 rounded-full bg-accent-500" />
                本期封面影像 · 校园走廊的黄昏
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
}